import { useState } from "react";

import { ColocaButton } from "@/shared/components/buttons/ColocaButton";
import { ColocaDialog } from "@/shared/components/overlays/ColocaDialog";
import useTranslations from "@/shared/lang/useTranslations";

import { BrebKeyFlow, BrebKeyWizardStepper } from "./BrebKeyFlow";

export interface BrebKeyDialogProps {
  open: boolean;
  onClose: () => void;
  organizationId?: string;
}

export function BrebKeyDialog({ open, onClose, organizationId }: BrebKeyDialogProps) {
  const { t } = useTranslations("payins");
  const [step, setStep] = useState<number | null>(null);
  return (
    <ColocaDialog
      open={open}
      onOpenChange={(next) => {
        if (!next) onClose();
      }}
      size="xl"
      mobileFullscreen
      title={t("breb_key_label")}
      toolbar={open && step !== null && <BrebKeyWizardStepper currentStep={step} />}
      footer={
        <ColocaButton variant="ghost" onClick={onClose}>
          {t("breb_key_close")}
        </ColocaButton>
      }
    >
      {open && <BrebKeyFlow organizationId={organizationId} onStepChange={setStep} />}
    </ColocaDialog>
  );
}
